/**
 * Tour steps for the Upload page.
 */
const uploadSteps = [
  {
    target: '[data-tour="upload-dropzone"]',
    title: 'Drop your PDF here 📄',
    content:
      'Drag-and-drop a lab report right here — we\'ll extract key health values and add them to your timeline automatically.',
    placement: 'bottom',
    route: '/upload',
    tourName: 'upload',
  },
  {
    target: '[data-tour="upload-reports-list"]',
    title: 'Your uploaded reports',
    content:
      'All your previously uploaded reports appear here. You can review details, see extracted metrics, or remove any report.',
    placement: 'top',
    route: '/upload',
    tourName: 'upload',
    navigateOnNext: '/timeline',
  },
];

export default uploadSteps;
